<template>
  <div class="topbar flex justify-center items-center mx-auto h-full py-2" data-test="top-bar">
    <span class="h-full" v-if="logoUrl">
      <img class="h-full" :src="logoUrl" />
    </span>
    <span v-if="text" v-html="text" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    logoUrl: { type: String },
    text: { type: String },
  },
});
</script>
